import React from "react";

import "../styles.scss";
import "../scripts";

import {
  KameleonElement,
  primaryCollectionBlock,
  getDefaultProps,
  renderTertiaryBlock,
} from "@kameleon-core/lib";
import { Box } from "theme-ui";
import {
  BackgroundColors as ThemeBackgroundColors,
  Variants,
} from "@kameleon-util/global-theme";
import {
  blockConfig,
  ContentCollectionItem,
} from "./components/content-collection-item";

import blockinfo from "./blockinfo.json";
import defaults from "./defaults.json";
import { ContentCollectionType, layoutOptions } from "./types/prop-types";

export const ContentCollection = primaryCollectionBlock<ContentCollectionType>(
  blockConfig,
  ({
    PrimaryBlocks,
    tagline,
    title,
    description,
    TertiaryBlock,
    layoutProps,
  }: ContentCollectionType) => {
    const primaryBlockLayoutProps = { ...layoutProps };
    primaryBlockLayoutProps.backgroundColor =
      ThemeBackgroundColors.neutralLight;

    return (
      <Box className="primary-collection-content-collection-two-col-stacking-cards-v1 section_layout353">
        <Box className="padding-global container-large padding-section-large layout353_component">
          <Box className="layout353_content-left">
            {tagline && (
              <Box className="margin-bottom margin-xsmall">
                <Variants.TagLine>{tagline}</Variants.TagLine>
              </Box>
            )}
            <Box className="margin-bottom margin-small">
              <Variants.Heading>{title}</Variants.Heading>
            </Box>
            <Variants.ParagraphMedium>{description}</Variants.ParagraphMedium>
            {TertiaryBlock && renderTertiaryBlock(TertiaryBlock)}
          </Box>
          <Box className="layout353_content-right">
            {PrimaryBlocks?.slice(0, 6).map((primaryBlockProps, i) => {
              const primaryProps = { ...primaryBlockProps };
              primaryProps.layoutProps = primaryBlockLayoutProps;
              return (
                <Box key={i} sx={{ top: `${10 + i * 2}%`, position: "sticky" }}>
                  <ContentCollectionItem {...primaryProps} />
                </Box>
              );
            })}
          </Box>
        </Box>
      </Box>
    );
  }
);

ContentCollection.defaultProps =
  getDefaultProps<ContentCollectionType>(defaults);

export const Element: KameleonElement = {
  component: ContentCollection,
  blockInfo: blockinfo,
  defaultProps: {
    layoutProps: defaults.layoutProps,
    contentProps: defaults.contentProps,
  },
  layoutOptions,
};
